var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-out"}},[_c('div',{staticClass:"loading-part"},[_c('div',{staticClass:"loading-rects"},[_c('div',{staticClass:"rect-middle"},[_c('div',{staticClass:"rect-1"},[_c('div',{staticClass:"side",class:{ active: _vm.loadingProgress >= 25 },style:({
              width:
                _vm.loadingProgress >= 25
                  ? `55px`
                  : `${55 * (_vm.loadingProgress / 25)}px`
            })}),_c('div',{staticClass:"side",class:{ active: _vm.loadingProgress >= 50 },style:({
              height:
                _vm.loadingProgress >= 50
                  ? `55px`
                  : `${55 * (_vm.loadingProgress / 50)}px`
            })}),_c('div',{staticClass:"side",class:{ active: _vm.loadingProgress >= 75 },style:({
              width:
                _vm.loadingProgress >= 75
                  ? `55px`
                  : `${55 * (_vm.loadingProgress / 75)}px`
            })}),_c('div',{staticClass:"side",class:{ active: _vm.loadingProgress >= 100 },style:({
              height:
                _vm.loadingProgress >= 100
                  ? `55px`
                  : `${55 * (_vm.loadingProgress / 100)}px`
            })}),_c('img',{staticClass:"rect-center-logo",staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/images/virsody-single.logo.png"),"alt":""}})]),_c('div',{staticClass:"rect-2"}),_c('div',{staticClass:"rect-3"}),_c('div',{staticClass:"rect-4"})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }